import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import PaginationBasic from 'components/Pagination/Pagination';
import _ from 'lodash';
import React, { ReactNode } from 'react';
import { IHeaderTable } from 'types/tables';

interface ITableBasicProps {
    children: ReactNode;
    hasData?: boolean;
    hasHeader?: boolean;
    column?: IHeaderTable[];
    size?: 'small' | 'medium';
    textNotFound?: string;
    hasPagination?: boolean;
    currentPage?: number;
    totalPages?: number;
    handleSetPage?: (pageNew: number) => void;
    isLoading?: boolean;
    loadingComponent?: ReactNode;
}

const TableBasic = (props: ITableBasicProps) => {
    const {
        children,
        hasData = false,
        hasHeader = false,
        column,
        size = 'small',
        textNotFound = 'No Record Found',
        hasPagination = false,
        totalPages,
        currentPage,
        handleSetPage,
        isLoading = false,
        loadingComponent
    } = props;

    return (
        <>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer component={Paper} sx={{ display: 'flex', justifyContent: 'space-between', maxHeight: '65vh' }}>
                    <Table stickyHeader sx={{ minWidth: 450 }} size={size}>
                        {hasHeader && (
                            <TableHead>
                                <TableRow sx={{ width: '100%' }} selected>
                                    {column?.map((col: IHeaderTable, index) => (
                                        <TableCell key={index} align={col.align || 'left'} sx={{ maxWidth: col.width || 'unset' }}>
                                            <Typography variant="h4">{col.name}</Typography>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                        )}

                        <TableBody sx={{ width: '100%', maxHeight: '20vh !important' }}>
                            {/* Show data */}
                            {children}
                            {isLoading &&
                                _.map([1, 2, 3, 4, 5, 6, 7, 8, 10], (item) => (
                                    <React.Fragment key={item}>{loadingComponent}</React.Fragment>
                                ))}
                            {/* No result */}
                            {!isLoading && !hasData && (
                                <TableRow>
                                    <TableCell colSpan={column?.length}>
                                        <Grid container spacing={4} flexDirection="row">
                                            <Grid
                                                item
                                                xs={12}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    minHeight: '50vh'
                                                }}
                                            >
                                                <Typography variant="h3">{textNotFound}</Typography>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {hasPagination && totalPages ? (
                    <PaginationBasic currentPage={currentPage} total={totalPages} callBack={handleSetPage} paddingt={1} />
                ) : null}
            </Paper>
        </>
    );
};

export default TableBasic;
